<template>
  <SmallModal
    :is-open="show"
    @close="closeModal"
  >
    <template #header> Assign Vehicle & Drivers </template>

    <div class="my-2 mb-4">
      <label
        class="block text-xs font-semibold uppercase"
        :class="{ 'text-gray-600': !canAssignDriverOne, 'text-gray-700': canAssignDriverOne }"
        for="driverOne"
        >Driver 1</label
      >
      <div class="input-control overflow-hidden">
        <select
          v-model="driverOne"
          id="driverOne"
          :disabled="!canAssignDriverOne"
          class="block w-full rounded-md border-gray-400 bg-gray-100 focus:ring-0 font-semibold truncate"
          :class="{
            'text-gray-600': !driverOne,
            'text-gray-800': driverOne,
            'bg-gray-300 cursor-not-allowed': !canAssignDriverOne
          }"
        >
          <option
            hidden
            :value="undefined"
          >
            <template v-if="!canAssignDriverOne">
              {{ driverOneList }}
            </template>
            <template v-else>Select driver one</template>
          </option>
          <option
            v-for="driver in driverOptions"
            :value="driver.value"
          >
            {{ driver.label }}
          </option>
        </select>
      </div>
    </div>
    <div class="my-2 mb-4">
      <label
        class="block text-xs font-semibold text-gray-700 uppercase"
        for="driverTwo"
        >Driver 2</label
      >
      <div class="input-control">
        <select
          v-model="driverTwo"
          id="driverTwo"
          class="block w-full rounded-md border-gray-400 bg-gray-100 focus:ring-0 font-semibold truncate"
          :class="{ 'text-gray-600': !driverTwo, 'text-gray-800': driverTwo }"
        >
          <option
            hidden
            :value="undefined"
          >
            Select driver two
          </option>
          <option
            v-for="driver in driverOptions"
            :value="driver.value"
          >
            {{ driver.label }}
          </option>
        </select>
      </div>
    </div>
    <div class="my-2">
      <label
        class="block text-xs font-semibold text-gray-700 uppercase"
        for="vehicle"
        >Vehicle</label
      >
      <div class="input-control">
        <select
          v-model="vehicleId"
          class="block w-full rounded-md border-gray-400 bg-gray-100 focus:ring-0 font-semibold truncate"
          :class="{ 'text-gray-600': !vehicleId, 'text-gray-800': vehicleId }"
        >
          <option
            hidden
            :value="undefined"
          >
            Select vehicle
          </option>
          <option
            v-for="vehicle in vehicles"
            :value="vehicle.id"
          >
            {{ vehicle.license_plate_number }}
          </option>
        </select>
      </div>
    </div>
    <template #footer>
      <button
        type="button"
        @click="submitAssign"
        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
      >
        Assign
      </button>
      <button
        type="button"
        class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-gray-100 text-base font-medium text-gray-700 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 sm:ml-3 sm:w-auto sm:text-sm"
        @click="closeModal"
      >
        Cancel
      </button>
    </template>
  </SmallModal>
</template>

<script setup>
import SmallModal from '@/Components/Modals/SmallModal.vue'
import { computed, ref } from 'vue'
import _ from 'lodash'

const emits = defineEmits(['close', 'assign'])

const props = defineProps({
  show: Boolean,
  vehicles: Array,
  drivers: Array,

  canAssignDriverOne: {
    type: Boolean,
    required: true
  },
  driverOneList: {
    type: String,
    required: false
  }
})

const driverOne = ref(undefined)
const driverTwo = ref(undefined)
const vehicleId = ref(undefined)

const driverOptions = computed(() => {
  return _.map(props.drivers, (user) => ({ value: user.id, label: user.first_name + ' ' + user.last_name }))
})

const submitAssign = () => {
  emits('assign', vehicleId.value, driverOne.value, driverTwo.value)
}

const closeModal = () => {
  driverOne.value = undefined
  driverTwo.value = undefined
  vehicleId.value = undefined
  emits('close')
}
</script>
